import * as React from "react";
import { FormComponent } from "../../../../../react-core/Html/FormComponent";
import { WizardLabel } from "../../Resources/Content";
import { TextBoxEditor } from "../../../../../react-core/Html/TextBoxEditor";
import { TransferWizardAction } from "../../Actions/TransferWizardAction";
import { DestinationSubAccountStore } from "../../Stores/Variable";
import { Pager } from "../../../../../react-core/Html/Pager";
import { TransferDestinationAccountModel } from "../../../../../Wrap/Models/Domains/Transfer/TransferDestinationAccountModel";
import { TransferDestinationAccountPaginatedModel } from "../../../../../Wrap/Models/Domains/Transfer/TransferDestinationAccountPaginatedModel";
import { PartLoading } from "../../../../../react-core/Html/PartLoading";
import { ServiceProposition } from "../../../../../Wrap/Constants/Enums/ServiceProposition";
import { accountStatusMap } from "../../../../Dashboard/Components/Clients/ClientRecord/Resource/Contents";

interface IDestinationAccountSearchPopupProps extends React.Props<DestinationAccountSearchPopup> {
    selectDesAccount: (acc: TransferDestinationAccountModel) => void;
    servicePropostion: ServiceProposition;
}

interface IDestinationAccountSearchPopupState {
    isLoading: boolean;
    accountName: string;
    accountNum: string;
    forename: string;
    surname: string;
    currentPage: number;
    pageSize: number;
    tableData: TransferDestinationAccountPaginatedModel;
}

export class DestinationAccountSearchPopup extends FormComponent<
    IDestinationAccountSearchPopupProps,
    IDestinationAccountSearchPopupState
> {
    constructor(props: any) {
        super(props);
        this.state = {
            isLoading: false,
            accountName: "",
            accountNum: "",
            forename: "",
            surname: "",
            currentPage: 1,
            pageSize: 10,
            tableData: null,
        };
        this.subscribeToStore(DestinationSubAccountStore, () => this.onStoreChange());
    }

    private onStoreChange() {
        const account = DestinationSubAccountStore.getAccounts();
        if (account) {
            this.setState({ tableData: account, isLoading: false });
        }
    }

    private onSelect(acc: TransferDestinationAccountModel) {
        this.props.selectDesAccount(acc);
    }

    private getData(pageIndex: number): void {
        const { accountName, accountNum, forename, surname, pageSize } = this.state;
        const min = (pageIndex - 1) * pageSize + 1;
        const max = min + pageSize - 1;
        this.setState({ isLoading: true });
        TransferWizardAction.getDestinationAccount(
            accountName,
            accountNum.trim(),
            forename.trim(),
            surname.trim(),
            max,
            min,
            this.props.servicePropostion
        );
    }

    private onSearch(): void {
        this.getData(1);
    }

    private renderSearch(): JSX.Element {
        return (
            <>
                <div className="row">
                    <div className="col-12 col-sm-4">
                        <TextBoxEditor
                            value={this.state.accountName}
                            label={WizardLabel.desAccountPopup.accountName}
                            onChange={(v) => {
                                this.setState({ accountName: v });
                            }}
                        />
                    </div>
                    <div className="col-12 col-sm-4">
                        <TextBoxEditor
                            value={this.state.accountNum}
                            label={WizardLabel.desAccountPopup.accountNum}
                            onChange={(v) => {
                                this.setState({ accountNum: v });
                            }}
                        />
                    </div>
                    <div className="col-12 col-sm-4">
                        <TextBoxEditor
                            value={this.state.forename}
                            label={WizardLabel.desAccountPopup.clientforename}
                            onChange={(v) => {
                                this.setState({ forename: v });
                            }}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 col-sm-4">
                        <TextBoxEditor
                            value={this.state.surname}
                            label={WizardLabel.desAccountPopup.clientsurname}
                            onChange={(v) => {
                                this.setState({ surname: v });
                            }}
                        />
                    </div>
                    <div className="col-12 col-sm-4">
                        <button className="btn secondary label-offset" onClick={() => this.onSearch()}>
                            {WizardLabel.desAccountPopup.search}
                        </button>
                    </div>
                </div>
            </>
        );
    }

    private renderThead(): JSX.Element {
        return (
            <thead>
                <tr>
                    <th>{WizardLabel.desAccountPopup.accountNameTable}</th>
                    <th>{WizardLabel.desAccountPopup.accountNumTable}</th>
                    <th>{WizardLabel.desAccountPopup.status}</th>
                    <th>{WizardLabel.desAccountPopup.adviser}</th>
                    <th></th>
                </tr>
            </thead>
        );
    }

    private renderTbody(data: TransferDestinationAccountModel[], TotalRows: number): JSX.Element {
        return (
            <tbody className="body-split">
                <tr>
                    <td colSpan={5}>{`Total ${TotalRows ? TotalRows : 0} Clients`}</td>
                </tr>
                {data.map((ele, index) => {
                    return (
                        <tr key={ele.ClAccountId + index}>
                            <td>{ele.Name}</td>
                            <td>{ele.ClAccountId}</td>
                            <td>{accountStatusMap[ele.Status]}</td>
                            <td>{ele.PrimaryAdviser}</td>
                            <td>
                                <button className="btn secondary" onClick={() => this.onSelect(ele)}>
                                    {WizardLabel.desAccountPopup.select}
                                </button>
                            </td>
                        </tr>
                    );
                })}
            </tbody>
        );
    }

    private renderPagination() {
        const { currentPage, pageSize } = this.state;
        const { TotalRows } = this.state.tableData;
        return (
            <div className="row">
                <div className="col-12 col-right">
                    <Pager
                        pager={{
                            CurrentPage: currentPage,
                            ResultsPerPage: pageSize,
                            TotalPages: TotalRows / pageSize,
                            TotalRecords: TotalRows,
                        }}
                        onChange={(recordsPerPage: number, pageIndex: number) => {
                            this.setState({ currentPage: pageIndex });
                            this.getData(pageIndex);
                        }}
                        recordsPerPageOptions={[10, 15, 20]}
                        isShowPerPageOptions={false}
                    />
                </div>
            </div>
        );
    }

    render() {
        const { tableData, isLoading } = this.state;
        const data = tableData ? tableData.SubAccounts : [];
        return (
            <>
                {this.renderSearch()}
                {isLoading ? (
                    <PartLoading isLoading={true}>
                        <div className="table-skeleton"></div>
                    </PartLoading>
                ) : (
                    <table className="data-table">
                        {this.renderThead()}
                        {this.renderTbody(data, tableData ? tableData.TotalRows : 0)}
                    </table>
                )}
                {tableData && tableData.SubAccounts ? this.renderPagination() : null}
            </>
        );
    }
}
